//      
import getWindowFromEl from '../window/get-window-from-el';

export default function isElement(el        )                  {
  return el instanceof getWindowFromEl(el).Element;
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/is-type-of-element/is-element.js